/* tslint:disable */
/* eslint-disable */
/**
 * Property Management API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.0.2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ClientOfferIn
 */
export interface ClientOfferIn {
    /**
     * 
     * @type {number}
     * @memberof ClientOfferIn
     */
    clientId: number | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof ClientOfferIn
     */
    offerIds: Array<number>;
    /**
     * 
     * @type {string}
     * @memberof ClientOfferIn
     */
    mainLocation?: string;
    /**
     * 
     * @type {string}
     * @memberof ClientOfferIn
     */
    secondaryLocation?: string;
    /**
     * 
     * @type {string}
     * @memberof ClientOfferIn
     */
    module?: string;
}

export function ClientOfferInFromJSON(json: any): ClientOfferIn {
    return ClientOfferInFromJSONTyped(json, false);
}

export function ClientOfferInFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClientOfferIn {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'clientId': json['clientId'],
        'offerIds': json['offerIds'],
        'mainLocation': !exists(json, 'mainLocation') ? undefined : json['mainLocation'],
        'secondaryLocation': !exists(json, 'secondaryLocation') ? undefined : json['secondaryLocation'],
        'module': !exists(json, 'module') ? undefined : json['module'],
    };
}

export function ClientOfferInToJSON(value?: ClientOfferIn | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'clientId': value.clientId,
        'offerIds': value.offerIds,
        'mainLocation': value.mainLocation,
        'secondaryLocation': value.secondaryLocation,
        'module': value.module,
    };
}


